import securityService from "./securityService";
import adapterSecurityCheck from "./adapter-security-check";
import ComponentNames from "../../../resources/generated/components.json";
import { ComponentKeys } from "../componentService/component-service";

const module = {};

module.checkWithLicenseValidation = function(adapter, sourceType) {
    const isFabricSolution = securityService.isFabricSolution();
    // Striim target does not have an adapter, So hard-coding it to true, So it doesnot get disabled
    if (sourceType === "Striim") return true;
    // Always enable Sentinel and Foreseer components
    if (
        sourceType === ComponentNames.TransformationSentinel[ComponentKeys.HumanReadableName] ||
        sourceType === ComponentNames.Foreseer[ComponentKeys.HumanReadableName]
    )
        return true;
    const isAdapterEnabled = adapterSecurityCheck.checkIfEnabled([adapter]);

    if (adapter?.toLowerCase() === "databasereader" && isAdapterEnabled) {
        if (isFabricSolution && sourceType !== "SQL Server" && sourceType !== "SQL Server Initial Load") {
            return false;
        }
    }
    return isAdapterEnabled;
};

export default module;
